"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Demo = function Demo() {
  var _theme$useToken = _antd.theme.useToken(),
    token = _theme$useToken.token;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: 12,
      background: token.colorFillSecondary
    }
  }, /*#__PURE__*/_react.default.createElement(_antd.Slider, {
    defaultValue: 30
  }), /*#__PURE__*/_react.default.createElement(_antd.Slider, {
    range: true,
    defaultValue: [20, 50]
  }));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorFillSecondary', 'colorFillContentHover', 'colorBgContainer', 'colorPrimary', 'colorPrimaryHover', 'colorPrimaryBorderHover', 'colorPrimaryBorder'],
  key: 'sliderInBg'
};
var _default = exports.default = componentDemo;